module.exports = __webpack_public_path__ + "static/media/Product_image_placeholder.6df9f72a.jpg";